import { api } from "@/lib/api";

export const certError = async (e) => {
  const d = e?.response?.data;
  if (d instanceof Blob) {
    try { return JSON.parse(await d.text()).detail; } catch (_) { return "Something went wrong. Please try again."; }
  }
  return typeof d?.detail === "string" ? d.detail : "Something went wrong. Please try again.";
};

export const pdfBlob = async (id, download = false) =>
  (await api.get(`/certificates/${id}/pdf${download ? "?download=1" : ""}`, { responseType: "blob" })).data;

export const downloadCert = async (c) => {
  const url = URL.createObjectURL(await pdfBlob(c.id, true));
  const a = document.createElement("a");
  a.href = url;
  a.download = `${c.certificate_number}.pdf`;
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 10000);
};

export const printCert = async (c) => {
  const url = URL.createObjectURL(await pdfBlob(c.id));
  const f = document.createElement("iframe");
  f.style.cssText = "position:fixed;right:0;bottom:0;width:0;height:0;border:0";
  f.src = url;
  f.onload = () => setTimeout(() => { f.contentWindow.focus(); f.contentWindow.print(); }, 300);
  document.body.appendChild(f);
  setTimeout(() => { f.remove(); URL.revokeObjectURL(url); }, 120000);
};

export const waUrl = (phone, message) => `https://wa.me/${phone || ""}?text=${encodeURIComponent(message)}`;

export const canShareFiles = () => {
  try { return !!navigator.canShare && navigator.canShare({ files: [new File([""], "a.pdf", { type: "application/pdf" })] }); } catch (_) { return false; }
};

export const nativeSharePdf = async (c, message) => {
  const blob = await pdfBlob(c.id, true);
  const file = new File([blob], `${c.certificate_number}.pdf`, { type: "application/pdf" });
  await navigator.share({ files: [file], text: message, title: c.certificate_number });
};

export const successFromDp = (c) => ({ kind: "dp", id: c.id, name: c.full_name, code: c.fe_id, city: c.city || c.location, state: c.state, certificate: c.certificate, certificate_error: c.certificate_error });
export const successFromFranchise = (c) => ({ kind: "franchise", id: c.id, name: c.name, code: c.referral_number, city: c.city, state: c.state, certificate: c.certificate, certificate_error: c.certificate_error });

export const location = (c) => [c?.city, c?.state].filter(Boolean).join(", ") || "-";
